import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import EdapModuleView from '../EdapModuleView';
import LazyBackgroundImage from '../LazyBackgroundImage';
import { handleEdapClick } from '../../utils/edap';
import { MODULE_VIEW_EVENT_OPTIONS, OWNER_LYP_CLICK } from './events';
import { Link } from '@homeaway/react-localization-components';

import './Lyp.less';

const CNAME = 'Lyp';

const Lyp = ({ title, callToActionText, callToActionUrl, imageUrl }) => (
  <section className="Content__section">
    <EdapModuleView eventOptions={MODULE_VIEW_EVENT_OPTIONS}>
      <LazyBackgroundImage
        className={cnames(CNAME, 'jumbotron', 'jumbotron-inverse')}
        imageUrl={imageUrl}
      >
        <div className={`${CNAME}__overlay`} />
        <div className="container">
          <h2 className={`${CNAME}__title`}>{title}</h2>
          {callToActionUrl &&
            <Link href={callToActionUrl} className="lyp__btn btn btn-lg btn-overlay">{callToActionText}</Link>
          }
        </div>
        {callToActionUrl &&
          <Link onClick={handleEdapClick(OWNER_LYP_CLICK)} aria-label={callToActionText} href={callToActionUrl} className={`${CNAME}__overlay-link`} />
        }
      </LazyBackgroundImage>
    </EdapModuleView>
  </section>
);

Lyp.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  callToActionText: PropTypes.string,
  callToActionUrl: PropTypes.string
};

export default Lyp;
